module.exports = __webpack_public_path__ + "static/media/back.ca28a249.png";